import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as blocks from "./style.module.scss";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material';
import { data } from "./data"

const StyledAccordion = styled(Accordion)({
  boxShadow: "unset",
  backgroundColor: "unset",
  marginBottom: "30px",
  "&:last-child": {
    marginBottom: 0,
  },
  "&::before": {
    display: "none",
  },
  "@media (max-width: 600px)": {
    marginBottom: "20px",
  },
});

const StyledSummary = styled(AccordionSummary)({
  background: '#222222',
  borderRadius: "15px",
  cursor: "pointer",
  padding: "20px",
  width: "100%",
  border: "none",
  textAlign: "left",
  outline: "none",
  fontSize: "15px",
  transition: "0.4s",
  color: '#F2E6FF',
  fontWeight: "400",
  position: "relative",
  "@media (max-width: 600px)": {
    padding: "20px",
  },
  "::before": {
    display: "inline-block",
    content: '""',
    margin: "auto 50px auto 0",
    width: "120px",
    height: "120px",
    flexShrink: 0,
    backgroundSize: "contain",
    "@media (max-width:575px)": {
      display: "none",
    },
  },
  "&:after": {
    content: "''",
    position: "absolute",
    top: "calc(50% - 19px)",
    right: "40px",
    width: "43px",
    height: "43px",
    backgroundImage: "url(https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/arrow.svg)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    "@media (max-width: 600px)": {
      top: "20px",
      right: "20px",
      width: "30px",
      height: "30px",
    },
  },
  "&.Mui-expanded": {
    background: '#5E4990',
    "&:after": {
      backgroundImage: "url(https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/arrow-active.svg)"
    }
  },
  ".MuiAccordionSummary-content": {
    margin: 0,
    paddingRight: "70px",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 600px)": {
      paddingRight: "35px",
    }
  },
});

const StyledDetails = styled(AccordionDetails)({
  padding: "40px",
  color: '#FFFFFF',
  background: 'rgba(34,34,34,0.45)',
  boxShadow: "0 0 15px rgba(0,0,0,0.15)",
  overflow: "hidden",
  fontWeight: 300,
  fontSize: "18px",
  lineHeight: "120%",
  borderRadius: "0 0 15px 15px",
  "@media (max-width: 600px)": {
    margin: "20px",
  },
  "p": {
    marginBottom: "20px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "ul": {
    paddingLeft: "20px",
    marginBottom: "40px",
  },
  "ul li": {
    listStyle: "disc",
  },
  "@media (max-width: 991px)": {
    padding: "20px",
  },
  "@media (max-width: 767px)": {
    padding: "10px",
  }
})

export const BlocksStructure = () => {
  return (
    <section className={blocks.structure} id={"courseStructure"}>
      <div className={"container"}>
        <h2 className={`${main.titleH2} ${blocks.title}`}>Структура курса и навыки</h2>
        <p className={blocks.description}>
          Программа состоит из 5 блоков, которые переплетены друг с другом и&nbsp;обеспечивают плавное и&nbsp;увлекательное прохождение курса.
          <br/><br/>
          Каждый блок развивает свой набор необходимых ребенку навыков:
        </p>
        {data.map((elem, index) => (
          <StyledAccordion disableGutters={true} key={index} square>
            <StyledSummary sx={{
              "::before": {
                background: `url(${elem.icon}) center center no-repeat`,
              }
            }}>
              <span className={blocks.bage}>{elem.bage}</span>
              <h3 className={blocks.header}>
                {elem.title}
              </h3>
            </StyledSummary>
            <StyledDetails>
              {elem.description}
            </StyledDetails>
          </StyledAccordion>
        ))}
      </div>
    </section>
  );
};
